<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"

    dark
    app
    purple
    floating
    persistent
    mobile-break-point="991"
    width="220"
  >
    <!--<v-img
      :src="image"
      height="100%"
    >-->
    <v-layout
      class="fill-height"
      tag="v-list"
      column>
      <v-list-tile avatar>
        <v-img
          :src="logo"
          contain
          class="logo"
          @click="NavigateToClaims"/>
      </v-list-tile>
      <v-divider />
<!--      <v-list-tile v-if="responsive">-->
<!--        <v-text-field-->
<!--          class="red-input search-input"-->
<!--          label="Search..."-->
<!--          color="red" />-->
<!--      </v-list-tile>-->

      <div v-if="credentials.isAuthorized">
        <v-list-tile
          :class="{ secondary: clickedDrawer === 'claims' }"
          avatar
          class="v-list-item"
          @click="NavigateToClaims"
        >
          <v-list-tile-action>
            <v-icon>mdi-file</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="font-weight-light">
            {{ 'krita.menu.claims' | translate }}
          </v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-if="disabled"
          :class="{ secondary: clickedDrawer === 'customers'}"
          avatar
          class="v-list-item"
          @click="NavigateToCustomers">
          <v-list-tile-action>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="font-weight-light">
            Customers
          </v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          :class="{ secondary: clickedDrawer === 'reports'}"
          avatar
          class="v-list-item"
          @click="NavigateToReports" >
          <v-list-tile-action>
            <v-icon>mdi-chart-line</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="font-weight-light">
            {{ 'krita.menu.reports' | translate }}
          </v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-if="disabled"
          :class="{ secondary: clickedDrawer === 'documents' }"
          avatar
          class="v-list-item"
          @click="NavigateToDocuments">
          <v-list-tile-action>
            <v-icon>mdi-folder</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="font-weight-light">
            Documents
          </v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-if="disabled"
          :class="{ secondary: clickedDrawer === 'settings' }"
          avatar
          class="v-list-item"
          @click="NavigateToSettings">
          <v-list-tile-action>
            <v-icon>mdi-settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="font-weight-light">
            Settings
          </v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-if="disabled"
          :class="{ secondary: clickedDrawer === 'help-contact' }"
          active-class="primary"
          avatar
          class="v-list-item"
          @click="NavigateToHelpContact">
          <v-list-tile-action>
            <v-icon>mdi-information-outline</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="font-weight-light">
            Help & Contact
          </v-list-tile-title>
        </v-list-tile>
      </div>

      <v-list-tile
        v-if="credentials.isAuthorized"
        avatar
        active-class="primary"
        class="v-list-item v-list__tile--buy"
        @click="LogOut">
        <v-list-tile-action>
          <v-icon>mdi-logout</v-icon>
        </v-list-tile-action>
        <v-list-tile-title class="font-weight-light">
          {{ 'krita.menu.logout' | translate }}
        </v-list-tile-title>
      </v-list-tile>

    </v-layout>
    <!--</v-img>-->
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {
  mapMutations,
  mapState
} from 'vuex';

export default {
  data: () => ({
		logo: require('../../assets/logo.png'),
		responsive: false,
	  	disabled: false,
  }),
  computed: {
    ...mapState('app', ['image', 'color', 'credentials']),
    ...mapState(['credentials']),
    clickedDrawer () {
        switch (this.$root.$route.name) {
          case 'Claims':
            return 'claims';
          case 'Reports':
            return 'reports';
      }
    },
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    items () {
      return this.$t('Layout.View.items')
    }
  },
  mounted () {
    this.onResponsiveInverted();
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
	},
	NavigateToClaims() {
		this.$router.push('/claims');
	},
	NavigateToCustomers() {
		this.$router.push('/customers');
	},
	NavigateToReports() {
		this.$router.push('/reports/pending');
	},
	NavigateToDocuments() {
		this.$router.push('/documents');
	},
	NavigateToSettings() {
		this.$router.push('/settings');
	},
	NavigateToHelpContact() {
		this.$router.push('/help-contact');
	},
	  LogOut(){
		this.$router.push('/log-in');
		this.$store.commit('logOut');
	  }
  }
}
</script>

<style scoped lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 9px;
      height: 60%;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }
  }

  .logo{
    height: 240px;
    max-width: 150px;
    margin: auto;
  }
</style>
